export function resolveErrorMessage(err: unknown): string {
	if (err && typeof err === 'object' && 'response' in err) {
		const status = (err as { response?: { status?: number } }).response?.status;
		switch (status) {
			case 401:
				return 'Sin permisos para estos datos (401)';
			case 403:
				return 'Acceso no autorizado a este módulo (403)';
			case 429:
				return 'Demasiadas peticiones — esperá unos segundos e intentá de nuevo (429)';
			case 503:
				return 'Este módulo no está disponible en este entorno (503)';
			default:
				if (status && status >= 500) return `Error del servidor (${status}) — intentá de nuevo en unos segundos`;
				if (status && status >= 400) return `Error al obtener los datos (${status})`;
		}
	}

	// Sin respuesta del servidor (timeout, red caída, CORS, etc.)
	if (err && typeof err === 'object' && 'request' in err) {
		return 'No se pudo conectar con el servidor — verificá tu conexión';
	}

	if (err instanceof Error) return err.message;
	return 'Error inesperado al cargar los datos';
}
